import { Util } from 'playback-web-player';

const ONE_MINUTE = 60000;

const memoizeConnection = (
    getIsConnectionOk = Util.getIsConnectionOk,
    cacheResetMs = ONE_MINUTE
) => {
    let cache = null;
    return async () => {
        if (cache) return cache;

        const isConnectionOk = await getIsConnectionOk();
        isConnectionOk && setTimeout(() => cache = null, cacheResetMs);

        cache = isConnectionOk;
        return cache;
    };
};

export default memoizeConnection;
